import { useTileDataContext } from '~/context/srp/TileDataContext';

export default function YearMakeModel() {
  const {
    tileData: { make, model, year }
  } = useTileDataContext();

  return (
    <p
      className="font-bold leading-[24px] text-[18px] truncate"
      data-qa="make-model"
    >
      {year} {make} {model}
    </p>
  );
}
